import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import FinishesPage from "@/pages/FinishesPage";
import ProcessPage from "@/pages/ProcessPage";
import GalleryPage from "@/pages/GalleryPage";
import Admin from "@/pages/Admin";

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#151310",
              border: "1px solid rgba(239,230,211,0.14)",
              color: "#efe6d3",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/finishes" element={<SiteLayout><FinishesPage /></SiteLayout>} />
          <Route path="/process" element={<SiteLayout><ProcessPage /></SiteLayout>} />
          <Route path="/gallery" element={<SiteLayout><GalleryPage /></SiteLayout>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
